import styled from 'styled-components';

import { Adaptive, palette, lighten, makeFullWidth } from '../../styles';

type RootProps = {
	appearance?: 'danger' | 'warning' | 'success' | 'default';
} & Adaptive;

const getCss = (appearance: RootProps['appearance']) => {
	const q = 0.85;
	const map = {
		'danger': `
			background-color: ${lighten(palette.dangerPrimary, q)};
			color: ${palette.blackPrimary};
			border-color: ${palette.dangerPrimary};
		`,
		'warning': `
			background-color: ${lighten(palette.warningPrimary, q)};
			color: ${palette.blackPrimary};
			border-color: ${palette.warningPrimary};
		`,
		'success': `
			background-color: ${lighten(palette.accentPrimary, q)};
			color: ${palette.blackPrimary};
			border-color: ${palette.accentPrimary};
		`,
		'default': `
			background-color: ${lighten(palette.blackSecondary, q)};
			color: ${palette.blackPrimary};
			border-color: ${palette.blackSecondary};
		`,
	};

	return map[appearance];
};

const Root = styled.div<RootProps>`
	position: relative;
	display: inline-block;
	height: auto;
	max-width: 100%;
	padding: 16px;
	text-align: left;
	border-radius: 2px;
	border: 1px solid transparent;

	${p => `
		${getCss(p.appearance)}
	`}

	${p => makeFullWidth(p)}
`;

export {
	Root
}